import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

export const getLocalDateOnly = (date) => {
  if (date) {
    return moment(date).local().format(DATE_FORMAT);
  }

  return null;
};

export const getLocalDatetime = (datetime) => {
  if (datetime) {
    const _datetime = moment(datetime).utc(true).toISOString();
    return _datetime.replace('Z', '');
  }

  return null;
}